var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kotlin-original-wordmark-a",
    gradientUnits: "userSpaceOnUse",
    x1: "-4.046",
    x2: "13.694",
    y1: "59.126",
    y2: "39.749"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#1c93c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".163",
    stopColor: "#2391c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".404",
    stopColor: "#378bbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".696",
    stopColor: "#587eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".995",
    stopColor: "#7f6cb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kotlin-original-wordmark-b",
    gradientUnits: "userSpaceOnUse",
    x1: "1.085",
    x2: "30.957",
    y1: "74.46",
    y2: "43.285"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#c757a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".046",
    stopColor: "#ca5a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".241",
    stopColor: "#d66779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".428",
    stopColor: "#e17357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".6",
    stopColor: "#e97c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".756",
    stopColor: "#ef8324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".888",
    stopColor: "#f28817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".982",
    stopColor: "#f48912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kotlin-original-wordmark-c",
    gradientUnits: "userSpaceOnUse",
    x1: "14.38",
    x2: "31.487",
    y1: "92.496",
    y2: "74.781"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#1c93c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".216",
    stopColor: "#2d8ebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".64",
    stopColor: "#587eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".995",
    stopColor: "#7f6cb1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 42.6h22.2L0 64.5z",
    fill: "url(#kotlin-original-wordmark-a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 85.4l42.8-42.8H21.6L0 63.9z",
    fill: "url(#kotlin-original-wordmark-b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4 85.4L21.2 64.2 0 85.4z",
    fill: "url(#kotlin-original-wordmark-c)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50 75.6V52.8h5.1v9.8l9.3-9.8h5.8l-9.3 9.8 9.3 13h-5.8l-6.8-9.5-2.5 2.5v7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5 58.2c-5.1 0-9.2 3.9-9.2 8.7 0 4.8 4.1 8.7 9.2 8.7s9.2-3.9 9.2-8.7c0-4.8-4.1-8.7-9.2-8.7zm0 13.6c-2.7 0-4.9-2.2-4.9-4.9s2.2-4.9 4.9-4.9 4.9 2.2 4.9 4.9-2.2 4.9-4.9 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9 53.8H93v4.5h4v4.2h-4v8.2s1.5 2.1 4 0v4.5s-4 2-7.5 0c0 0-1.6-1.6-1.6-3.5v-9.2h-2v-4.4l2 .1v-4.4zM98.5 51.9h4.9v23.7h-4.9zM105.2 51.9h5v4.2h-5zM105.2 58.3h5v17.3h-5zM111.9 58.3h5.1V61s4.7-7.2 10.4 0l.5 1.5v13.1h-5V65s-2.8-5.3-5.9 0v10.6h-5.1V58.3z"
  })));
};